import { useCallback, useState } from 'react';
import { createContext } from 'use-context-selector';
import { api } from 'core/services/api';


export const AuthenticationContext = createContext();

export const AuthenticationProvider = ({ children }) => {

  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const [isAdmin, setIsAdmin] = useState(false);
  const [user, setUser] = useState({});

  const signIn = useCallback(async ({ email, password }) => {
    const response = await api.post('auth/login', {
      email,
      password,
    });

    if (response.data.success) {
      let { user, access_token } = response.data;

      window.localStorage.setItem('@token', access_token);

      api.defaults.headers.authorization = access_token || "";

      setUser(user);
      setIsAdmin(Boolean(user.admin))
      setIsAuthenticated(true);
    }

    return response.data

  }, []);

  const logout = useCallback(async () => {

    window.localStorage.removeItem('@token');
    api.defaults.headers.authorization = "";

    setUser({});
    setIsAdmin(false)
    setIsAuthenticated(false);

  }, []);

  const initializeAuth = useCallback((user) => {
    setIsAuthenticated(true)
    setIsAdmin(user.admin)
    setUser(user);
  }, [])

  return (
    <AuthenticationContext.Provider
      value={{
        userId: user.id,
        user: user,
        signIn,
        initializeAuth,
        logout,
        isAuthenticated,
        isAdmin
      }}
    >
      {children}
    </AuthenticationContext.Provider>
  );
};
